// TODO [post-honeycomb-nerv-migration]: remove this function, use linksPersonalisation from DataContext directly.

export const resolveLinksPersonalisation = ({
  fromNerv,
  isLoadingFromNerv,
  fromPortal,
}) => {
  if (isLoadingFromNerv) {
    return null;
  }

  if (fromNerv?.questionResponses) {
    return { ...fromPortal, ...fromNerv };
  }

  return fromPortal ?? null;
};
